import React from 'react';
import { useT } from '../../i18n/LanguageContext';

export default function IntegrationCaveats({ graph, transportKnown, sendingAs }) {
  const t = useT();
  // Standing caveats that no status field can express.
  return (
    <div className="bg-white border border-[#e2e8f0] rounded-[14px] shadow-sm p-6">
      <p className="text-[12px] font-semibold text-[#64748b] uppercase tracking-wider mb-3">
        {t('Worth knowing')}
      </p>
      <ul className="text-[13px] text-[#64748b] space-y-3">
        <li>
          <span className="font-semibold text-[#0f172a]">
            {t('Nothing on this page enables sending.')}
          </span>{' '}
          {t(
            'Order forms stay blocked until VENDOR_EMAIL_ENABLED is set to the exact string "true", and every send still needs an admin confirmation after reading a preview.'
          )}
        </li>
        {graph ? (
          <>
            <li>
              <span className="font-semibold text-[#0f172a]">
                {t('The client secret expires.')}
              </span>{' '}
              {t(
                'Entra app secrets have a fixed lifetime, and when this one lapses order forms fail with AADSTS7000222 while everything else keeps working normally. Note the expiry date on the app registration and rotate before it.'
              )}
            </li>
            <li>
              <span className="font-semibold text-[#0f172a]">
                {t('Replies land on the vendor thread.')}
              </span>{' '}
              {t(
                '{mailbox} is the address on every historical vendor thread, so a vendor replying to an order form continues the conversation where the rest of the history already is.',
                { mailbox: sendingAs || t('The Microsoft mailbox') }
              )}
            </li>
            <li>
              <span className="font-semibold text-[#0f172a]">
                {t('Tracking notifications arrive at the Microsoft mailbox,')}
              </span>{' '}
              {t(
                'not at the Google one. An Outlook rule on it redirects the two BLS senders to the Google mailbox so the app can read them - redirect, not forward, which is what keeps the original sender and message id the matcher depends on. Deleting that rule stops tracking numbers without any error appearing here.'
              )}
            </li>
          </>
        ) : transportKnown ? (
          <li>
            <span className="font-semibold text-[#0f172a]">
              {t('Replies go to the sending mailbox,')}
            </span>{' '}
            {t(
              'which is not the address on the historical vendor threads. Confirm a vendor received the first send before relying on this channel.'
            )}
          </li>
        ) : null}
        <li>
          <span className="font-semibold text-[#0f172a]">
            {t('If the Google connection starts failing about a week after connecting,')}
          </span>{' '}
          {t(
            'the Google Cloud app is still in Testing. Google expires those refresh tokens after 7 days. Publish the app, then connect once more.'
          )}
        </li>
        <li>
          <span className="font-semibold text-[#0f172a]">{t('To revoke the Google grant,')}</span>{' '}
          {t(
            'the mailbox owner removes MedEffects at myaccount.google.com/permissions. There is no disconnect button here because only Google can actually sever it.'
          )}
        </li>
      </ul>
    </div>
  );
}
